module.exports = __webpack_public_path__ + "static/media/M1-20-Avanya-Neev-cod129.70556f96.png";